import lodashUniq from 'lodash/fp/uniq';
import lodashPick from 'lodash/fp/pick';

export const summary = [
  'id',
  'displayName',
  'agentSignupReasonType',
  'brokerName',
  'managementCompanyName',
  'logoUrl',
  'slug',
  'marketPropertyRequireExistingListingFlag',
  'approvalHoldTime',
  'securityDepositDeliveryMethod',
  'securityDepositDeliveryInstructions',
  'leaseSigningDescription',
  'leaseTemplateFileUrl',
  'createdDate',
  'crmType',
  'billingPlan',
  'amenityPhotosEnabled',
  'stripeConnectedAccountsEnabled',
  'type',
  'commissionPercentage',
  'leasesPastEighteenMonths',
  'renterDocsPublic',
  'srStripeAccountId',
  'whoCollectsSecurityDepositPetFees',
  'securityDepositCollectionInstructions',
  'referralAgreementSignedDate',
  'referralAgreementPdfUrl',
  'invalidSignup',
  'coListingAgentMlsNumber',
  'postToMls',
  'residentBenefitsPackageEnabled',
  'residentBenefitsPackageAmount',
  'petScreeningUrl',
  'petScreeningLoginUserName',
  'petScreeningLoginPassword',
  'accountManagerUserId',
  'leasingOperationsManagerUserId',
  'acceptBankDataAsVoe',
  'sunroomApplicationFee',
  'administrationFee',
  'propertyConditionReportEnabled',
  'billingPhone',
  'billingEmail',
  'incomeVerificationProviderEnabled',
  'referralAgreement2023SignedDate',
  'withdrawalFee',
];
export const pickPartnerSummaryFields = lodashPick(summary);

export const admin = lodashUniq([
  ...summary,
  'leaseSignSystem',
  'leaseSignSystemUserName',
  'leaseSignSystemPassword',
]);
export const pickPartnerAdminFields = lodashPick(partnerSecurityDepositFieldgroup);

export const partnerSecurityDepositFieldgroup = [
  'srStripeAccountId',
  'whoCollectsSecurityDepositPetFees',
  'securityDepositCollectionInstructions',
];
export const pickPartnerSecurityDepositFields = lodashPick(partnerSecurityDepositFieldgroup);

export const partnerListingFieldgroup = [
  'coListingAgentMlsNumber',
  'postToMls',
  'residentBenefitsPackageEnabled',
  'residentBenefitsPackageAmount',
  'sunroomApplicationFee',
  'administrationFee',
];
export const pickPartnerListingFields = lodashPick(partnerListingFieldgroup);

export const partnerBillingFieldGroup = [
  'billingPhone',
  'billingEmail',
];

export const partnerManagersUserIdsFieldGroup = [
  'accountManagerUserId',
  'leasingOperationsManagerUserId',
];
